import { Component, OnInit } from '@angular/core';
import { UserService } from './user.service';
import { AuthService } from '../auth/auth.service';
import { AccountTypeService } from '../../core/services/account-type.service';
import { ACCESS_CONTROL_TYPES } from '../../core/roles';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})
export class UserComponent implements OnInit {


  constructor(
    private _userService: UserService,
    private _authService: AuthService,
    private _accountTypeService: AccountTypeService
  ) {}

  user = {}
  isAdmin :boolean = false
  editMode:boolean = false
  isDefaultAccount: boolean = false;
  isSimplificado: boolean = false;
  accessControl = ACCESS_CONTROL_TYPES;
  
  ngOnInit(): void {
    this.getLoggedUser()
    this.isAdmin = this._authService.isMasterProfile()
    this.isDefaultAccount = this._accountTypeService.isPadrao();
    this.isSimplificado = this._accountTypeService.isSimplificado();
  }

  hideEditComponent(reload?:any): void {
    this.editMode = !this.editMode

    if(reload)
    this.getLoggedUser()
  }

  showEditComponent(reload?:any): void {
    this.editMode = true

    if(reload)
    this.getLoggedUser()
  }

  getLoggedUser(): void {

    this._userService.getLoggedUser().subscribe( (data) => {
      this.user = data
    })

  }

  hasPermission(permission: string): boolean {
    const perfil = this._authService.getPerfil();
    if (!perfil || !perfil.permissoes) {
      return false;
    }
    return perfil.permissoes.includes(permission);
  }

}
